export default __webpack_public_path__ + "static/media/img-profile2.071c9e98.jpg";